module.exports = __webpack_public_path__ + "img/ready-to-meal-banner.979ef597.png";